import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import englishCareer from "../data/CdataEN";
import frenchCareer from "../data/CdataFR";
import imageCareer_EN from "../images/PhotoCareer_EN.png";
import imageCareer_FR from "../images/PhotoCareer_FR.png";
import logo from "../images/logo.png";
import CareerCard from "./CareerCard";

const CarrerSection = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const imageSrc = language === "fr" ? imageCareer_FR : imageCareer_EN;

  const [careers, setCareers] = useState(
    i18n.language === "fr" ? frenchCareer : englishCareer
  );

  useEffect(() => {
    // Update service data whenever language changes
    setCareers(i18n.language === "fr" ? frenchCareer : englishCareer);
  }, [i18n.language]);

  return (
    <section className="container my-5">
       <div className="d-flex justify-content-center mb-4">
        <img
          src={imageSrc}
          className="img-fluid"
          alt="career"
          style={{
            maxHeight: "400px",
            objectFit: "contain",
          }}
        />
      </div>
      <h2 className="text-center mb-4"><strong>{t("our_offer")}</strong></h2>
      <div className="row justify-content-center  animate__animated animate__fadeInDown">
        {careers.map((carrer, index) => (
          <CareerCard
            key={index}
            icon={carrer.icon}
            title={carrer.title}
            details={carrer.details}
            detailData={carrer.detailData}
          />
        ))}
      </div>
      <div className="d-flex justify-content-center mb-4">
        <img
          src={logo}
          className="img-fluid"
          alt="carriere"
          style={{
            maxHeight: "200px",
            objectFit: "contain",
          }}
        />
      </div>
    </section>
  );
};

export default CarrerSection;
